<template>
  <b-row
    class="margin-0 margin-bottom-100 padding-16 background-surface border--solid border--complementary-50 border-radius-8"
  >
    <b-col cols="12" lg="4" class="padding-0">
      <b-row class="margin-0">
        ‍<b-col
          v-if="IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR"
          cols="12"
          class="padding-0 flex-end-start margin-bottom-16"
        >
          <!-- <Input
            :title="$lang.recommendedScore"
            :label="$lang.recommendedScore"
            :placeholder="$lang.recommendedScore"
            :value="form.recommendedScore"
            name="recommendedScore"
            id="recommendedScore"
            type="text"
            :vuelidateObj="$v.form.recommendedScore"
            rowClass="width-percent-100"
            :disabled="!hasItemPermission(['INDICATOR_SUGGESTION_SCORE'])"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          /> -->
          <EnumDropdown
            :title="$lang.recommendedScore"
            :label="$lang.recommendedScore"
            :placeholder="$lang.recommendedScore"
            :value="form.recommendedScore"
            name="recommendedScore"
            id="recommendedScore"
            categoryName="competency_score"
            :vuelidateObj="$v.form.recommendedScore"
            :parentOptions="finalScoreOptions"
            :disabled="true"
            :showArrowIcon="false"
            rowClass="width-percent-100"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
          <Button
            :disabled="!hasItemPermission(['INDICATOR_SUGGESTION_SCORE'])"
            wrapperClass="margin-right-8"
            contentClass="justify-content-center"
            variant="complementary-400"
            :text="$lang.computing"
            :loading="computingLoading"
            @click="handleComputeRecommendedScore"
          />
        </b-col>
        <b-col
          v-if="IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR"
          cols="12"
          class="padding-0 margin-bottom-16 margin-top-8"
        >
          <EnumDropdown
            :title="$lang.finalScore"
            :label="$lang.finalScore"
            :placeholder="$lang.finalScore"
            :value="form.finalScore"
            name="finalScore"
            id="finalScore"
            categoryName="competency_score"
            :vuelidateObj="$v.form.finalScore"
            :parentOptions="finalScoreOptions"
            :disabled="!hasItemPermission(['INDICATOR_FINAL_SCORE'])"
            rowClass=""
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col
      cols="12"
      :lg="IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR ? 8 : 12"
      class="padding-0"
      :class="{
        'padding-right-16':
          checkScreenDevice(['desktop']) &&
          IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR,
      }"
    >
      <Input
        :title="`${$lang.descriptionAndOtherTips} (${$lang.optional})`"
        :label="$lang.descriptionAndOtherTips"
        :placeholder="$lang.descriptionAndOtherTips"
        :value="form.description"
        name="description"
        id="description"
        type="textarea"
        :vuelidateObj="$v.form.description"
        rowClass="margin-bottom-16"
        :textareaRows="5"
        @input="input"
        :disabled="!hasItemPermission(['INDICATOR_DESCRIPTION'])"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
    <b-col cols="12" class="padding-0 flex-end">
      <Button
        v-if="hasItemPermission(['INDICATOR_SUGGESTION_SCORE'])"
        wrapperClass=""
        contentClass="justify-content-center"
        variant="primary"
        :text="$lang.submit"
        :loading="loading"
        @click="handleSubmitForm"
      />
    </b-col>
  </b-row>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Input, EnumDropdown, Button } from "@/components/re-design/forms";
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import {
  checkScreenDevice,
  generateError,
  generateLang,
  renderEumOptions,
  toastAlert,
} from "@/shared/utils";
import {
  editCenterExecuteCaseCompetency,
  setComputeCompetencyRecommendedScore,
} from "@/modules/kanoon/services/center-execute-services";
export default {
  mixins: [inputMixin],
  inject: [
    "CENTER_EXECUTE_ID",
    "CASE_ID",
    "COMPETENCY_ID",
    "GET_COMPETENCIES_DATA",
    "hasItemPermission",
    "IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR",
    "HAS_CHECKED_EVIDENCE_ITEM_IN_ANY_INDICATORS",
  ],
  components: { Input, EnumDropdown, Button },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        recommendedScore: {
          required: requiredIf(
            () => this.IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR
          ),
        },
        finalScore: {
          required: requiredIf(
            () => this.IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR
          ),
        },
        description: {},
      },
    };
  },
  data() {
    return {
      form: {
        recommendedScore: null,
        finalScore: null,
        description: null,
      },
      computingLoading: false,
      loading: false,
    };
  },
  computed: {
    finalScoreOptions() {
      const options = renderEumOptions("competency_score", true);
      return options.map((option) => {
        if (option.id === 0) {
          option.caption = option.caption.replace("0", "w");
        }
        return option;
      });
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(data) {
        this.GET_COMPETENCIES_DATA(false);
        if (data) {
          this.form.recommendedScore = this.finalScoreOptions.find(
            ({ id }) => id === this.covertScore(data.recommendedScore)
          );

          this.form.description = data.description;
          // select final score
          this.form.finalScore = this.finalScoreOptions.find(
            ({ id }) => id === this.covertScore(data.finalScoreId)
          );
        }
      },
    },
  },
  methods: {
    checkScreenDevice,
    covertScore(val) {
      return val === "w" ? 0 : val;
    },
    async handleComputeRecommendedScore() {
      try {
        this.computingLoading = true;
        const { CENTER_EXECUTE_ID: centerExecuteId, CASE_ID: caseId } = this;
        const { competencyId } = this.data;
        const response = await setComputeCompetencyRecommendedScore(
          centerExecuteId,
          caseId,
          competencyId
        );
        let { score } = response;
        this.form.recommendedScore = this.finalScoreOptions.find(
          ({ id }) => id === this.covertScore(score)
        );
      } catch (error) {
        generateError(error);
      } finally {
        this.computingLoading = false;
      }
    },
    async handleSubmitForm() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      const {
        CENTER_EXECUTE_ID: centerExecuteId,
        CASE_ID: caseId,
        COMPETENCY_ID: competencyId,
      } = this;

      const { description } = this.form;

      try {
        this.loading = true;
        let recommendedScore = pathOr(
          null,
          ["recommendedScore", "id"],
          this.form
        );
        let finalScoreId = pathOr(null, ["finalScore", "id"], this.form);

        // get recommended score and set to recommended score and final score when competency scoring method is not by assessor
        if (!this.IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR) {
          await this.handleComputeRecommendedScore();
          recommendedScore = pathOr(
            null,
            ["recommendedScore", "id"],
            this.form
          );
          finalScoreId = recommendedScore;
        }

        if (
          this.IS_COMPETENCY_SCORING_METHOD_BY_ASSESSOR &&
          !this.HAS_CHECKED_EVIDENCE_ITEM_IN_ANY_INDICATORS &&
          !includes(finalScoreId, [0, 1])
        ) {
          return toastAlert(
            generateLang(["notAnyEvidenceItemSelected"]),
            "warning"
          );
        }

        const response = await editCenterExecuteCaseCompetency({
          centerExecuteId,
          caseId,
          competencyId,
          recommendedScore,
          finalScoreId,
          description,
        });
        const { message } = response;
        toastAlert(message);
        this.GET_COMPETENCIES_DATA(false);
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
